webpackJsonp([23],{

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("b2144818", content, true);

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".setup[data-v-4cecfc56]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Setup.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"Setup.vue","sourcesContent":["\n.setup[data-v-4cecfc56] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/api/currentExpert.js
var currentExpert = __webpack_require__(172);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var components_inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Setup.vue








/* harmony default export */ var Setup = ({
  data: function data() {
    return {
      error: {},
      form: {
        category: null,
        firstName: null,
        lastName: null,
        birthday: null,
        phone: null
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform',
    expert: 'skiliko/session/currentUser',
    loading: 'skiliko/session/isLoading'
  }), {
    canEditPlatform: function canEditPlatform() {
      return currentExpert["a" /* default */].isAdmin(this.expert) && this.platform.need_informations;
    },
    inputs: function inputs() {
      var _this = this;

      return [this.canEditPlatform ? { key: 'category', required: true, component: components_inputs["d" /* CategoryInput */] } : null, { key: 'firstName', required: true, component: components_inputs["t" /* TextInput */] }, { key: 'lastName', required: true, component: components_inputs["t" /* TextInput */] }, { key: 'birthday', required: true, component: components_inputs["f" /* DateInput */] }, { key: 'phone', required: true, component: components_inputs["n" /* PhoneInput */] }].filter(function (e) {
        return e;
      }).map(function (input) {
        return extends_default()({}, input, {
          label: _this.$t('pages.setup.labels.' + input.key),
          errors: (_this.error[input.key] || []).map(function (e) {
            return function () {
              return e;
            };
          })
        });
      });
    },
    expertData: function expertData() {
      return {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        birthday: new Date(this.form.birthday),
        phone: this.form.phone
      };
    },
    platformData: function platformData() {
      return this.canEditPlatform ? { category: this.form.category } : {};
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    updateCurrentUser: 'skiliko/session/updateCurrentUser',
    updateCurrentPlatform: 'skiliko/session/updateCurrentPlatform'
  }), {
    submit: function submit() {
      var _this2 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.updateCurrentUser({ data: _this2.expertData });

              case 3:
                if (!currentExpert["a" /* default */].isAdmin(_this2.expert)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return _this2.updateCurrentPlatform({ data: _this2.platformData });

              case 6:
                _this2.$router.replace({ path: _this2.$route.query.redirect || '/' });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this2.error = (_context.t0.response || {}).data || {};

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 9]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cecfc56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Setup.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"setup"},[_c('v-card-title',[_vm._v("\n      "+_vm._s(_vm.$t('pages.setup.title'))+"\n    ")]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._l((_vm.inputs),function(input){return _c(input.component,{key:input.key,tag:"component",attrs:{"config":input},model:{value:(_vm.form[input.key]),callback:function ($$v) {_vm.$set(_vm.form, input.key, $$v)},expression:"form[input.key]"}})}),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","block":"","ripple":"","loading":_vm.loading}},[_vm._v("\n          "+_vm._s(_vm.$t('pages.setup.submit'))+"\n        ")])],2)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Setup = (esExports);
// CONCATENATED MODULE: ./src/pages/Setup.vue
function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cecfc56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Setup,
  pages_Setup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Setup = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/23.a9645482ca1ea2b053de.js